export default __webpack_public_path__ + "static/yellow-343b320695bd65ab04ce907b92e57e0c.gif";